// extracted by mini-css-extract-plugin
module.exports = {"box":"SearchableSelect_box__1_jwt","additionalMargin":"SearchableSelect_additionalMargin__kTVKY"};